import {getBalanceJWT} from "./Ledger";
import {encryptBigSecret, encryptSecret, signKBTransactionJWT} from "../Crypto/utils";
import {WebTools} from "../constants";
import axios from "axios";

const NODEJS_VERSIONS = {
    '20' : {
        url: `https://nodejs20.openkbs.com/`
    }
}

export const executeNodejs = async (userCode, KBData, version = '20') => {
    if (!NODEJS_VERSIONS?.[version]?.url) return;
    const {key, walletPrivateKey, walletPublicKey, accountId, kbId} = KBData;
    const balanceJWT = await getBalanceJWT(accountId, walletPrivateKey, walletPublicKey, key);
    if (!balanceJWT) return;

    const transactionJWT = await signKBTransactionJWT({
        toAccountId: WebTools["nodejs20"]?.accountId,
        ...KBData,
        message: 'function execution',
        maxAmount: 10000
    })

    const walletPrivateKeyEncryptedChunks = await encryptBigSecret(KBData?.walletPrivateKey);
    const AESKeyEncrypted = await encryptSecret(KBData?.key);

    const response =  await axios['post'](NODEJS_VERSIONS?.[version]?.url, {
        transactionJWT,
        balanceJWT,
        secrets: KBData?.secrets,
        AESKey: AESKeyEncrypted,
        walletPrivateKeyEncryptedChunks,
        walletPublicKey,
        // debug: true,
        userCode,
        kbId
    });

    return response;
};